// Layered shadow system — rgba(10,13,18,…) stacks, never harsh
export const shadows = {
  xs: '0 1px 2px rgba(10,13,18,0.05)',
  sm: '0 1px 3px rgba(10,13,18,0.10), 0 1px 2px rgba(10,13,18,0.06)',
  md: '0 4px 8px -2px rgba(10,13,18,0.10), 0 2px 4px -2px rgba(10,13,18,0.06)',
  lg: '0 12px 16px -4px rgba(10,13,18,0.08), 0 4px 6px -2px rgba(10,13,18,0.03)',
  xl: '0 20px 24px -4px rgba(10,13,18,0.08), 0 8px 8px -4px rgba(10,13,18,0.03)',
  card: '0 1px 2px rgba(10,13,18,0.06), 0 1px 3px rgba(10,13,18,0.10)',
} as const

export type Shadows = typeof shadows
